import axios from 'axios';
import React, { useState, useEffect } from 'react'
import { useForm } from '../../../hooks/useForm'
import { ApiUrl } from '../../../services/ApiRest';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import { RequestProductsSelect } from '../../guide/selects/RequestProductsSelect';
import { ProductSelectEdit } from './ProductSelectEdit';

export const EgressOfDay = () => {
    const [requestProductToAddSelected, setrequestProductToAddSelected] = useState(null);
    const [resetSelect, setResetSelect] = useState(false);
    const [reloadChild, setReloadChild] = useState(false);
    const [selectDisabled, setselectDisabled] = useState(true);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [data, setdata] = useState([]);
    const [productNameMerma, setproductNameMerma] = useState(null);
    const [resultTotal, setResultTotal] = useState("");
    const [quantitySaved, setQuantitySaved] = useState();
    const [mermaId, setmermaId] = useState();
    const [egressId, setegressId] = useState();
    const today = new Date().toISOString().split("T")[0];   // Obtener la fecha actual en formato YYYY-MM-DD      
    const [date, setDate] = useState(today);  // Estado para manejar la fecha, permitiendo su modificación
    const [totalEgreso, setTotalEgreso] = useState(0);
    const [totalMerma, setTotalMerma] = useState(0);
    const [sumatoriaTotal, setSumatoriaTotal] = useState(0);
    const [formD2, setformD2] = useState({
        quantity_em: 1,
        egress_mermas_id: null, // Si es necesario
        date_em: date,
    });
    const [formD, setformD] = useState({
        quantity_em: 1,
        description_em: '',
        type_em: '',
        total_price_em: '0.00',
        date_em: date,
        unit_price_em: '',
        egress_mermas_id: null, // Si es necesario
    });

    const onDataListUpdate = () => {
        console.log("Actualización de datos solicitada");
    };

    const onSubmitMerma = async (event) => {
        event.preventDefault();
        if (requestProductToAddSelected && requestProductToAddSelected.value) {
            const selectedProductId = requestProductToAddSelected.value.product_warehouses_id;
            const selectedProductLabel = requestProductToAddSelected.label;
            const selectedProductBuyingPrice = requestProductToAddSelected.value.buying_price;
            console.log('DATO PRECIOSSsss:', selectedProductBuyingPrice);
            if (!selectedProductId || !selectedProductLabel) {
                toast.error("Por favor, selecciona un producto válido.", { position: toast.POSITION.BOTTOM_RIGHT });
                return;
            }
            const quantityToAdd = formD2.quantity_em;
            console.log('CANTIDAD DE PRODUCTOS:', quantityToAdd);
            console.log('CANTIDAD DE PRODUCTOS DIRECTo:', formD2.quantity_em);
            // Validar que la cantidad sea un número positivo
            if (!quantityToAdd || isNaN(quantityToAdd) || quantityToAdd <= 0) {
                toast.error("Por favor, ingresa una cantidad válida.", { position: toast.POSITION.BOTTOM_RIGHT });
                return;
            }
            const availableQuantity = parseInt(selectedProductLabel.match(/\((\d+)\)/)[1], 10);
            // Validar que la cantidad a agregar no exceda la cantidad disponible
            if (quantityToAdd > availableQuantity) {
                toast.error("La cantidad solicitada excede la disponibilidad del producto.", { position: toast.POSITION.BOTTOM_RIGHT });
                return;
            }
            // Calcular el precio total
            const totalPrice = quantityToAdd * selectedProductBuyingPrice;
            const formData = new FormData();
            // formData.append("description_em", null);
            formData.append("product_warehouses_id", selectedProductId);
            formData.append("quantity_em", quantityToAdd);
            formData.append("type_em", 'Merma');
            formData.append("total_price_em", totalPrice);
            formData.append("status_em", '1');
            formData.append("date_em", date);
            console.log('Datos enviados al backend RESPUESTA:', Object.fromEntries(formData));
            try {
                const response = await axios.post(ApiUrl + 'mermas-add', formData);
                const resp = response.data;
                if (resp.success) {
                    toast.success("Producto agregado exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                    setReloadChild(!reloadChild);
                    deleteTable();
                    setformD2({
                        ...formD2,
                        quantity_em: 1,
                        date_em: '',
                    });
                    dataList();
                    setButtonDisabled(true);
                } else {
                    toast.error("El Producto no se ha agregado", { position: toast.POSITION.BOTTOM_RIGHT });
                }
            } catch (error) {
                console.log(error);
                toast.error("" + error + "  !", { position: toast.POSITION.BOTTOM_RIGHT });
            }
            setResetSelect(true);
            setResetSelect(false);
        } else {
            toast.error("Por favor, selecciona un producto antes de continuar", { position: toast.POSITION.BOTTOM_RIGHT });
        }
    };

    const onSubmitEgress = async (event) => {
        event.preventDefault();
        setButtonDisabled(true);
        // notify();
        const unitPrice = formD.unit_price_em;
        const quantityEg = formD.quantity_em;
        // Calcular el precio total
        const totalPriceEg = unitPrice * quantityEg;
        const f = new FormData();
        f.append("quantity_em", formD.quantity_em);
        f.append("description_em", formD.description_em);
        f.append("type_em", 'Egreso');
        f.append("unit_price_em", formD.unit_price_em);
        f.append("total_price_em", totalPriceEg);
        f.append("date_em", date);
        f.append("status_em", '1');
        console.log('DOSTOS ENVIADOS del backend:', Object.fromEntries(f));
        await axios.post(ApiUrl + 'egress-add', f)
            .then(response => {
                var resp = response.data;
                console.log(resp);
                if (resp.success) {
                    toast.success("Información agregada exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                    deleteTable();
                    dataList();
                    setformD({
                        quantity_em: 1,
                        description_em: '',
                        type_em: '',
                        total_price_em: '',
                        date_em: '',
                        unit_price_em: '',
                    });
                } else {
                    toast.error("La información no se ha agregado", { position: toast.POSITION.BOTTOM_RIGHT });
                }
            })
            .catch(e => {
                console.log(e)
                toast.error("" + e + "!", { position: toast.POSITION.BOTTOM_RIGHT });
            })
            .finally(() => {
                setButtonDisabled(false); // Habilitar el botón después de que la solicitud haya finalizado
            });
    }

    const onSubmitUpdateEgress = async (event) => {
        event.preventDefault();
        setButtonDisabled(true);
        const unitPrice = formD.unit_price_em;
        const quantityEg = formD.quantity_em;
        // Calcular el precio total
        const totalPriceEg = unitPrice * quantityEg;
        const f = new FormData();
        f.append("quantity_em", formD.quantity_em);
        f.append("description_em", formD.description_em);
        // f.append("type_em", 'Egreso');
        f.append("unit_price_em", formD.unit_price_em);
        f.append("total_price_em", totalPriceEg);
        f.append("date_em", formD.date_em);
        console.log('DOSTOS ENVIADOS del backend UPDATE EGRESS:', Object.fromEntries(f));
        try {
            const id_egress = formD.egress_mermas_id;
            console.log('Este es el id:', id_egress);
            const response = await axios.post(ApiUrl + `egress-update/${formD.egress_mermas_id}`, f);
            const resp = response.data;
            console.log('RESPUESTS UPDATE EGRESs:', resp);
            if (resp.success) {
                toast.success("Información actualizada exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                dataList();
            } else {
                toast.error("Información no actualizada", { position: toast.POSITION.BOTTOM_RIGHT });
            }
            setformD({
                quantity_em: '',
                description_em: '',
                type_em: '',
                total_price_em: '',
                date_em: date,
                unit_price_em: '',
            });
        } catch (error) {
            console.log(error);
            toast.error("" + error + "!", { position: toast.POSITION.BOTTOM_RIGHT });
        } finally {
            setButtonDisabled(false);
        };
    };

    const onSubmitUpdateMermas = async (event) => {
        event.preventDefault();
        setButtonDisabled(true);
        console.log("Valor actual de requestProductToAddSelected:", requestProductToAddSelected);
        event.preventDefault();
        const nombreProductoMerma = productNameMerma;
        console.log('Nombre merma PRODUCTO:', nombreProductoMerma);
        if (requestProductToAddSelected && requestProductToAddSelected.value) {
            const selectedProductId = requestProductToAddSelected.value.product_warehouses_id;
            const selectedProductLabel = requestProductToAddSelected.label;
            const selectedProductBuyingPrice = requestProductToAddSelected.value.buying_price;
            const selectedProductQuantity = requestProductToAddSelected.value.quantity;
            console.log('DATO PRECIOSSsss:', selectedProductBuyingPrice);
            console.log("ID del PRODUCTO antes de enviar QUANTITY:", selectedProductQuantity);
            if (!selectedProductId || !selectedProductLabel) {
                toast.error("Por favor, selecciona un producto válido.", { position: toast.POSITION.BOTTOM_RIGHT });
                return;
            }
            const quantityToAdd = formD2.quantity_em;
            console.log('CANTIDAD DE PRODUCTOS:', quantityToAdd);
            console.log('CANTIDAD DE PRODUCTOS DIRECTo:', formD2.quantity_em);
            // Validar que la cantidad sea un número positivo
            if (!quantityToAdd || isNaN(quantityToAdd) || quantityToAdd <= 0) {
                toast.error("Por favor, ingresa una cantidad válida.", { position: toast.POSITION.BOTTOM_RIGHT });
                return;
            }
            const availableQuantity = parseInt(selectedProductLabel.match(/\((\d+)\)/)[1], 10);
            // Validar que la cantidad a agregar no exceda la cantidad disponible
            if (quantityToAdd > availableQuantity) {
                toast.error("La cantidad solicitada excede la disponibilidad del producto.", { position: toast.POSITION.BOTTOM_RIGHT });
                return;
            }


            console.log('ID del PRODUCTO:', selectedProductId)
            console.log('ID del PRODUCTOVALOR ALMACENADO EN BD de MERMA:', quantitySaved);
            // Calcular el precio total
            const totalPrice = quantityToAdd * selectedProductBuyingPrice;
            let newResultTotal = "";

            if (quantitySaved < quantityToAdd) {
                const differenceProduct1 = quantityToAdd - quantitySaved;
                newResultTotal = selectedProductQuantity - differenceProduct1;
            } else if (quantitySaved > quantityToAdd) {
                const differenceProduct2 = quantitySaved - quantityToAdd;
                newResultTotal = selectedProductQuantity + differenceProduct2;
            }
            console.log('NEWRESULT TOTAL:', newResultTotal);
            // Actualizar el estado con el nuevo resultado
            setResultTotal(newResultTotal);

            const formData = new FormData();
            formData.append("quantity_em", quantityToAdd);
            formData.append("total_price_em", totalPrice);
            formData.append("product_warehouses_id", selectedProductId);
            formData.append("date_em", date);
            // formData.append("description_em", null);
            // formData.append("type_em", 'Merma');
            // formData.append("status_em", '1');
            console.log('Datos enviados al backend RESPUESTA EDITAR MERMA:', Object.fromEntries(formData));
            try {

                const id_mermas = formD2.egress_mermas_id;
                console.log('ver el ID merma:', id_mermas);
                // const response = await axios.post(ApiUrl + 'mermas-add', formData);

                const response = await axios.post(ApiUrl + `merma-update/${formD2.egress_mermas_id}`, formData);
                const resp = response.data;
                console.log('DATOS RESPUESTA dsdsd:', resp);
                console.log('DATOS RESPUESTA dsdsd product_warehouses_id:', response.data.ProductsWarId);
                // console.log("ID del almacén del producto:", response.data[0].product_warehouses_id);
                console.log('ID del almacén del producto:', response.data.ProductsWarId);

                console.log('Valor de ProductWarehouse que se envia desde el textVOx:', selectedProductId)
                console.log('SUCCESS:', resp.success);
                if (resp.success) {
                    toast.success("Información actualizada exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                    setReloadChild(!reloadChild);
                    deleteTable();
                    dataList();
                    setButtonDisabled(true);

                } else {
                    // toast.error("Información no actualizada", { position: toast.POSITION.BOTTOM_RIGHT });
                    toast.error("Debe elegir una cantidad diferente a la actual", { position: toast.POSITION.BOTTOM_RIGHT });
                }
            } catch (error) {
                console.log(error);
                toast.error("" + error + "  !", { position: toast.POSITION.BOTTOM_RIGHT });
            }
            setResetSelect(true);
            setResetSelect(false);
        } else {
            toast.error("Por favor, selecciona un producto antes de continuar", { position: toast.POSITION.BOTTOM_RIGHT });
        }
    };

    const onInputChange2 = (event) => {
        const { name, value } = event.target;
        // Si el campo modificado es la fecha, actualiza el estado de la fecha
        if (name === "date_em") {
            setDate(value);
        }
        // Convertir el valor de cantidad en número
        const quantity = parseInt(value, 10) || 0;
        // Verificar si hay un producto seleccionado y obtener su precio de compra
        var selectedProductBuyingPrice = (requestProductToAddSelected && requestProductToAddSelected.value)
            ? requestProductToAddSelected.value.buying_price
            : 0;
        // Calcular el total automáticamente
        const totalPrice = quantity * selectedProductBuyingPrice;
        // Actualizar el estado con la cantidad y el precio total calculado
        setformD2({
            ...formD2,
            [name]: value,
            total_price_em: totalPrice, // Actualiza el total en tiempo real
        });
    };

    const onInputChange = ({ target }) => {
        const { name, value } = target;
        // Si el campo modificado es la fecha, actualiza el estado de la fecha
        if (name === "date_em") {
            setDate(value);
        }
        // Actualiza el estado del formulario
        setformD((prevState) => {
            const updatedForm = { ...prevState, [name]: value };
            // Calcula el total_price_em si ambos valores están presentes
            if (name === 'quantity_em' || name === 'unit_price_em') {
                const quantity = parseFloat(updatedForm.quantity_em) || 0;
                const unitPrice = parseFloat(updatedForm.unit_price_em) || 0;
                updatedForm.total_price_em = (quantity * unitPrice).toFixed(2);
            }
            return updatedForm;
        })
    }

    const dataList = async () => {
        try {
            const response = await axios.get(ApiUrl + `mermas-list`);
            const responseData = response.data;
            setdata(responseData);
            console.log('DATALIST LISTADOoOOO:', responseData);
            // Calcular la suma total - Egresos
            const totalEgresoCalculado = responseData
                .filter(item => item.type_em === "Egreso") // Filtra solo los egresos
                .reduce((acc, item) => acc + parseFloat(item.total_price_em || 0), 0); // Suma los valores
            setTotalEgreso(totalEgresoCalculado);
            // Calcular la suma total - Mermas
            const totalMermasCalculados = responseData
                .filter(item => item.type_em === "Merma")
                .reduce((acc, item) => acc + parseFloat(item.total_price_em || 0), 0);
            setTotalMerma(totalMermasCalculados);
            // Sumatoria Total tanyo de Mermas y Egresos
            const sumaTotalME = responseData.reduce((acc, item) => acc + parseFloat(item.total_price_em || 0), 0);
            setSumatoriaTotal(sumaTotalME);
            const script = document.createElement("script");
            script.src = `/assets/dataTable/dataTable.js`;
            script.async = true;
            document.body.appendChild(script);
        } catch (error) {
            console.error(error);
        }
    };

    const deleteTable = () => {
        const script1 = document.createElement("script");
        script1.src = `/assets/dataTable/datatable-destroy.js`;
        script1.async = true;
        document.body.appendChild(script1);
    }

    const deleteMermas = async (egress_mermas_id) => {
        try {
            const response = await axios.post(ApiUrl + `merma-delete/${egress_mermas_id}`);
            const resp = response.data;
            if (resp.success === true) {
                toast.success("Producto eliminado exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                dataList();
                deleteTable();
            } else {
                toast.error("Producto no eliminado", { position: toast.POSITION.BOTTOM_RIGHT });
            }
        } catch (error) {
            console.log(error);
            toast.error("" + error + "!", { position: toast.POSITION.BOTTOM_RIGHT });
        }
    };

    const deleteEgress = async (egress_mermas_id) => {
        try {
            const response = await axios.post(ApiUrl + `egress-delete/${egress_mermas_id}`);
            const resp = response.data;
            if (resp.success === true) {
                toast.success("Producto eliminado exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                dataList();
                deleteTable();
            } else {
                toast.error("Producto no eliminado", { position: toast.POSITION.BOTTOM_RIGHT });
            }
        } catch (error) {
            console.log(error);
            toast.error("" + error + "!", { position: toast.POSITION.BOTTOM_RIGHT });
        }
    };

    useEffect(() => {
        dataList();
    }, []);


    return (
        <div>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="row align-items-center">
                                <div className="col-12 col-md-4 text-md-start">
                                    <b> EGRESOS Y MERMAS </b>
                                </div>
                                <div className="col-12 col-md-4 text-center">
                                    <b> HOY: {today} </b>
                                </div>
                                <div className="col-12 col-md-4 d-flex flex-column flex-md-row justify-content-md-end gap-2 mt-2 mt-md-0">
                                    <button className="btn btn-success btn-sm" data-bs-toggle="modal" data-bs-target="#addEgreso">
                                        <b>AGREGAR EGRESO</b> <i className="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                    <button className="btn btn-success btn-sm" data-bs-toggle="modal" data-bs-target="#addMerma">
                                        <b>AGREGAR MERMA</b> <i className="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className="row text-center">
                            <div className="col-12 col-md-4 mb-2 mb-md-0">
                                <h5><b>TOTAL EGRESO:</b> {totalEgreso.toFixed(2)}</h5>
                            </div>
                            <div className="col-12 col-md-4 mb-2 mb-md-0">
                                <h5><b>TOTAL MERMA:</b> {totalMerma.toFixed(2)}</h5>
                            </div>
                            <div className="col-12 col-md-4">
                                <h5><b>TOTAL EGRESOS Y MERMAS:</b> {sumatoriaTotal.toFixed(2)}</h5>
                            </div>
                        </div>
                        <br />
                        <div className="card-body table-responsive">
                            <table className="table table-hover" id="dataTable">
                                <thead>
                                    <tr>
                                        <th>Cantidad</th>
                                        <th>Descripción</th>
                                        <th>Tipo</th>
                                        <th>Valor total</th>
                                        <th>Fecha</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(data) &&
                                        data.map((item) => (
                                            <tr key={item.egress_mermas_id}>
                                                <td>{item.quantity_em}</td>
                                                <td>
                                                    {item.type_em === "Merma"
                                                        ? item.products_name_mer
                                                        : item.description_em}
                                                </td>
                                                <td>{item.type_em}</td>
                                                <td>{item.total_price_em}</td>
                                                <td>{item.date_em}</td>
                                                <td>
                                                    {item.type_em === "Merma" ? (
                                                        <button
                                                            className="btn btn-outline-primary"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#editMerma"
                                                            onClick={() => {
                                                                setformD2({
                                                                    quantity_em: item.quantity_em || "",
                                                                    products_name_mer: item.products_name_mer || "",
                                                                    type_em: item.type_em || "",
                                                                    total_price_em: item.total_price_em || "0.00",
                                                                    date_em: item.date_em || "",
                                                                    egress_mermas_id: item.egress_mermas_id || null,
                                                                });
                                                                console.log("producto ID:", item.egress_mermas_id);
                                                                setproductNameMerma(item.products_name_mer);
                                                                setQuantitySaved(item.quantity_em);
                                                            }}
                                                        >
                                                            <i className="fa fa-edit"></i>
                                                        </button>
                                                    ) : (
                                                        <button
                                                            className="btn btn-outline-primary"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#editEgreso"
                                                            onClick={() => {
                                                                setformD({
                                                                    quantity_em: item.quantity_em || "",
                                                                    description_em: item.description_em || "",
                                                                    type_em: item.type_em || "",
                                                                    total_price_em: item.total_price_em || "0.00",
                                                                    date_em: item.date_em || "",
                                                                    unit_price_em: item.unit_price_em || "",
                                                                    egress_mermas_id: item.egress_mermas_id || null,
                                                                });
                                                                console.log("precio unitario:", item.unit_price_em);
                                                            }}
                                                        >
                                                            <i className="fa fa-edit"></i>
                                                        </button>
                                                    )}
                                                    {item.type_em === "Merma" ? (
                                                        <button
                                                            className="btn btn-outline-danger"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#mermasDelete"
                                                            onClick={() => {
                                                                setmermaId(item.egress_mermas_id);
                                                            }}
                                                        >
                                                            <i className="fas fa-trash-alt"></i>
                                                        </button>
                                                    ) : (
                                                        <button
                                                            className="btn btn-outline-danger"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#egressDelete"
                                                            onClick={() => {
                                                                setegressId(item.egress_mermas_id);
                                                            }}
                                                        >
                                                            <i className="fas fa-trash-alt"></i>
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* AGREGAR EGRESOS */}
            <div className="modal fade" id="addEgreso" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <form onSubmit={onSubmitEgress}>
                            <div className="modal-header">
                                <p className="modal-title" id="exampleModalLabel"><b>AGREGAR NUEVO EGRESO</b></p>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-12 col-md-3'>
                                            <div className="">
                                                <label className="form-label">Cantidad (Opcional)</label>
                                                <input type="text" name='quantity_em' className="form-control" value={formD.quantity_em} onChange={onInputChange}  ></input>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-3'>
                                            <div className="">
                                                <label className="form-label">Precio Unitario</label>
                                                <input type="text" name='unit_price_em' className="form-control" value={formD.unit_price_em} onChange={onInputChange} required ></input>

                                            </div>
                                        </div>
                                        <div className='col-12 col-md-3'>
                                            <div className="">
                                                <label className="form-label">Precio total</label>
                                                <input type="text" className="form-control" name="total_price_em" value={formD.total_price_em} onChange={onInputChange} readOnly disabled ></input>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-3'>
                                            <div className="">
                                                <label className="form-label">Fecha</label>
                                                <input type="date" className="form-control" name="date_em" value={date} onChange={onInputChange} ></input>
                                            </div>
                                        </div>

                                        <div className='col-12 col-md-12'>
                                            <div className="">
                                                <label className="form-label">Descripción</label>
                                                <input type="text" name='description_em' className="form-control" value={formD.description_em} onChange={onInputChange} required ></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary" > Aceptar</button> &nbsp;
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* EDITAR EGRESOS */}
            <div className="modal fade" id="editEgreso" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <form onSubmit={onSubmitUpdateEgress}>
                            <div className="modal-header">
                                <p className="modal-title" id="exampleModalLabel"><b>EDITAR EGRESO</b></p>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-12 col-md-3'>
                                            <div className="">
                                                <label className="form-label">Cantidad (Opcional)</label>
                                                <input type="text" name='quantity_em' className="form-control" value={formD.quantity_em || ""} onChange={onInputChange}  ></input>
                                            </div>
                                        </div>

                                        <div className='col-12 col-md-3'>
                                            <div className="">
                                                <label className="form-label">Precio Unitario</label>
                                                <input type="text" name='unit_price_em' className="form-control" value={formD.unit_price_em || ""} onChange={onInputChange} required ></input>
                                            </div>
                                        </div>

                                        <div className='col-12 col-md-3'>
                                            <div className="">
                                                <label className="form-label">Precio total</label>
                                                <input type="text" className="form-control" name="total_price_em" value={formD.total_price_em || ""} onChange={onInputChange} readOnly disabled ></input>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-3'>
                                            <div className="">
                                                <label className="form-label">Fecha</label>
                                                <input type="date" className="form-control" name="date_em" value={formD.date_em} onChange={onInputChange} ></input>
                                            </div>
                                        </div>

                                        <div className='col-12 col-md-12'>
                                            <div className="">
                                                <label className="form-label">Descripción</label>
                                                <input type="text" name='description_em' className="form-control" value={formD.description_em || ""} onChange={onInputChange} required ></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary" data-bs-dismiss="modal"> Aceptar</button> &nbsp;
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* AGREGAR MERMA */}
            <div className="modal fade" id="addMerma" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <form onSubmit={onSubmitMerma} >
                            <div className="modal-header">
                                <p className="modal-title" id="exampleModalLabel"><b>AGREGAR NUEVA MERMA</b></p>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-12 '>
                                            <div className='row'>
                                                <div className='col-3'>
                                                    <div className="">
                                                        <label className="form-label">Cantidad</label>
                                                        <input type="number" name='quantity_em' className="form-control" step="1" placeholder='000' onChange={onInputChange2} value={formD2.quantity_em} required ></input>
                                                    </div>
                                                </div>
                                                <div className='col-9'>
                                                    <div className="form-group">
                                                        <label >Seleccionar producto (Cantidad disponible)</label>
                                                        <RequestProductsSelect
                                                            requestProductSelect={requestProductToAddSelected}
                                                            setrequestProductSelect={setrequestProductToAddSelected}
                                                            resetValue={resetSelect}
                                                            onDataListUpdate={onDataListUpdate}
                                                            reload={reloadChild}
                                                            disabled={selectDisabled}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-12 col-md-12'>
                                                    <div className="">
                                                        <label className="form-label">Fecha</label>
                                                        <input type="date" className="form-control" name="date_em" value={date} onChange={onInputChange2} ></input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary" > Aceptar</button> &nbsp;
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* EDITAR MERMA */}
            <div className="modal fade" id="editMerma" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <form onSubmit={onSubmitUpdateMermas}>
                            <div className="modal-header">
                                <p className="modal-title" id="exampleModalLabel"><b>EDITAR MERMA</b></p>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-12 '>
                                            <div className='row'>
                                                <div className='col-6'>
                                                    <div className="">
                                                        <label className="form-label">Cantidad</label>
                                                        <input type="number" name='quantity_em' className="form-control" step="1" placeholder='000' onChange={onInputChange2} value={formD2.quantity_em} required ></input>
                                                    </div>
                                                </div>
                                                <div className='col-6'>
                                                    <div className="">
                                                        <label className="form-label">Producto actual:</label>
                                                        <input className='form-control' onChange={onInputChange2} value={`${productNameMerma || ''} `} disabled></input>
                                                        {/* <input className='form-control' onChange={onInputChange2} value={`${resultTotal || ''} `} disabled></input> */}
                                                        {/* <input className='form-control' onChange={onInputChange2} value={resultTotal || productNameMerma} disabled /> */}

                                                        {/* <input className='form-control' onChange={onInputChange2} value={requestProductToAddSelected || ''} disabled></input> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-12 col-md-9'>
                                                    <div className="form-group">
                                                        <label >Seleccionar producto (Cantidad disponible)</label>
                                                        <ProductSelectEdit
                                                            requestProductSelect2={requestProductToAddSelected}
                                                            setrequestProductSelect2={setrequestProductToAddSelected}
                                                            resetValue={resetSelect}
                                                            onDataListUpdate={onDataListUpdate}
                                                            reload={reloadChild}
                                                            disabled={selectDisabled}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-12 col-md-3'>
                                                    <div className="">
                                                        <label className="form-label">Fecha</label>
                                                        <input type="date" className="form-control" name="date_em" value={date} onChange={onInputChange2} ></input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary" > Aceptar</button> &nbsp;
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* ELIMINAR EGRESS */}
            <div className="modal fade" id="egressDelete" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">ELIMINAR SUSCRIPCIÓN</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            ¿Está seguro que desea eliminar?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => deleteEgress(egressId)}>Aceptar</button>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ELIMINAR MERMAS */}
            <div className="modal fade" id="mermasDelete" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">ELIMINAR SUSCRIPCIÓN</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            ¿Está seguro que desea eliminar?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => deleteMermas(mermaId)}>Aceptar</button>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer theme="colored" />
        </div>
    )
}
